<template>
  <div class='main fc ac'>


       <img style='width: 260px;margin-top: 18px;' src='@/assets/index/文字@2x.png' alt />

    <div class="fr jc ac" style="margin-top: 40px;">

    <img class="item1" @click="go('/zxgxb')"  style="padding: 0;" src="../../assets//hscs/造血干基本简介_icon.png" alt="" srcset="">
    <img class="item1" @click="go('/changyishu')" style="padding: 0;" src="../../assets//hscs//倡议书.png" alt="" srcset="">
    <img class="item1"  @click="go('/baomingtiaojian')"  style="padding: 0;" src="../../assets//hscs/报名条件@2x.png" alt="" srcset="">
    </div>
 
    <div class="fr jc ac">
      <img class="item1" @click="go('/baomingliucheng')" style="padding: 0;" src="../../assets//hscs/报名流程.png" alt="" srcset="">
      <div class="item2" @click="go('/jiankang')"  style="background-color: #FDF94F;color: #FF0100;">捐献是否影响健康</div>
    </div> 

     
    <div class="fr jc ac">
      <div class="item2" @click="go('/heshikyjx')"  style="background-color: #FDF94F;color: #FF0100;">何时可以捐献</div>
      <img class="item1" @click="go('/caijiguocheng')"  style="padding: 0;" src="../../assets//hscs/采集过程@2x.png" alt="" srcset="">
    </div>

       <div class="fr jc ac">
        <img class="item1"  @click="go('/baomingdian')"  style="padding: 0;" src="../../assets//hscs/街镇报名点@2x.png" alt="" srcset="">
      <div class="item1"   @click="go('/zhiyuanzhefengcai')" style="background-color: #FDF94F;color: #FF0100;">志愿者风采</div>
      <img class="item1"  @click="go('/rukujianying')" style="padding: 0;" src="../../assets//hscs/入库剪影@2x.png" alt="" srcset="">
    </div>
 
  </div>
  </div>
</template>
  
<script>
export default {
  name: "home",
  data() {
    return {};
  },
  methods: {
    toZxgxb() {
      this.$router.push({
        path: "zxgxb"
      });
    },
    toJxxz() {
      this.$router.push({
        path: "jxxz"
      });
    },
    toCjd() {
      this.$router.push({
        path: "cjd"
      });
    },
    toJxlc() {
      this.$router.push({
        path: "jxlc"
      });
    },
    toSignUp() {
      this.$router.push({
        path: "/HSC/apply"
      });
    }
  },
  components: {},
  mounted() {}
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 44px;
  width: 100vw;
  // height: 100vh;
  min-height: 100vh;
  background-image: url("./../../assets/index/bg.png");
  background-size: contain;
}

.grid {
  margin-top: 38px;
  display: flex;
  .item {
    width: 143px;
    height: 143px;
  }
  .left {
    display: flex;
    flex-direction: column;
  }
  .right {
    display: flex;
    flex-direction: column;
  }
}

.item1 {
  width: 86px;
  height: 86px;
  border-radius: 8px;
  margin: 7px;
  display:flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
}
.item2 {
  width: 186px;
  height: 86px;
  border-radius: 8px;
  margin: 7px;
   display:flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px;
  font-weight: bold;
}
.w77 {
  width: 77px;
}
.h77 {
  height: 77px;
}
</style>